<template>
    <div>
        <!-- Modal para visualizar detalhes do pedido -->
        <div class="modal fade" id="mddetalhespedido" tabindex="-1" aria-labelledby="mdldetalhespedido" aria-hidden="true" style="z-index: 1051;">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdldetalhespedido"><i class="fa fa-info-circle"></i> Detalhes do pedido/venda</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="padding: 10px 0px 10px 0px;">
                        <div class="container-fluid" v-show="mostrar">
                            <div class="row">
                                <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label for="edclientepeddet">Cliente:</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" id="edclientepeddet" v-bind:value="detpedido.idcliente+' - '+detpedido.nomecliente"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label for="edfilialdet">Filial:</label>
                                    <input type="text" class="form-control form-control-sm" id="edfilialdet" v-bind:value="detpedido.idfilial+' - '+detpedido.fantasia"
                                        data-bv-group=".group" disabled/>
                                </div>							
                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="ednrpeddet">Nr. Pedido:</label>
                                    <input type="text" class="form-control form-control-sm text-right font-weight-bold text-secondary" id="ednrpeddet" v-bind:value="mtdformatarzeros(detpedido.id, 8)"
                                        data-bv-group=".group" disabled/>
                                        <span v-if="parseInt(detpedido.entregaexterna) === 1" class="badge badge-primary badge-pill" style="background-color: #5A956A; font-size: 16px; position: absolute; top: 25px; left: 20px;" title="Entrega externa"><i class="fa fa-truck" style="transform: scale(-1, 1);"></i></span>
                                        <span v-if="parseInt(detpedido.origem) === 5" class="badge badge-primary badge-pill" style="background-color: #2f3c48; font-size: 16px; position: absolute; top: 25px; left: 60px; width: 35px;" title="Origem App"><i class="fa fa-tablet"></i></span>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="eddtemissaodet">Emissão:</label>
                                    <input type="text" class="form-control form-control-sm text-right" id="eddtemissaodet" v-model="detpedido.dtregistro"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label for="edplanodet">Plano de pagamento:</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" id="edplanodet" v-model="detpedido.descplano"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="edtotalpedidodet">Total pedido:</label>
                                    <money type="text" class="form-control form-control-sm input-money" id="edtotalpedidodet" 
                                        v-model="detpedido.totalgeral" v-bind="money"
                                        data-bv-group=".group" style="text-align:right;" disabled>
                                    </money>                                
                                </div>
                                <div style="padding-top: 20px;" class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <template v-if="parseInt(detpedido.tipo) === 0">
										<span class="badge badge-primary btn-block badge-pill" style="background-color: #6BA2D0; padding: 10px;">PEDIDO</span>
                                    </template>
                                    <template v-else-if="parseInt(detpedido.tipo) === 1">
                                        <span class="badge badge-primary btn-block badge-pill" style="background-color: #EEA435; padding: 10px;">ORÇAMENTO</span>
                                    </template>
                                    <template v-else-if="parseInt(detpedido.tipo) === 2">
                                        <span class="badge badge-primary btn-block badge-pill" style="background-color: #A42F11; padding: 10px;">O. S.</span>
                                    </template>										
                                    <template v-else>
                                        <span class="badge badge-primary btn-block badge-pill" style="background-color: #74A82A; padding: 10px;">CASHBACK</span>
                                     </template>                                     
                                </div>
                                <div style="padding-top: 20px;" class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <template v-if="parseInt(detpedido.stpedido) === 0">
                                        <span style="padding: 10px;" class="badge badge-primary btn-block badge-pill">ABERTO</span>
                                    </template>
                                    <template v-else-if="parseInt(detpedido.stpedido) === 1">
                                        <span  class="badge badge-secondary btn-block badge-pill" style="background-color: #5A956A; padding: 10px">FATURADO</span>
                                    </template>
                                    <template v-else>
                                        <span style="padding: 10px;" class="badge badge-danger btn-block badge-pill">CANCELADO</span>
                                    </template>										                             
                                </div>
                                <div v-show="parseInt(detpedido.idguiarota) > 0" class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="edguiarotadet">Guia Rota:</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" id="edguiarotadet" v-bind:value="mtdformatarzeros(detpedido.idguiarota, 8)"
                                        data-bv-group=".group" disabled/>
                                    <span v-if="parseInt(detpedido.efetivadaguia) === 1" class="badge badge-primary badge-pill bdg-det-icone-guia" style="background-color: #5A956A; font-size: 16px;" title="Efetivada"><i class="fa fa-check"></i></span>
                                    <span v-else-if="parseInt(detpedido.situacaoguia) === 0" class="badge badge-primary badge-pill bdg-det-icone-guia" style="background-color: #EEA435; font-size: 16px;" title="Em digitação"><i class="fa fa-keyboard-o"></i></span>
                                    <span v-else class="badge badge-primary badge-pill bdg-det-icone-guia" style="background-color: #6BA2D0; font-size: 16px;" title="Em rota"><i class="fa fa-truck"></i></span>
                                </div>                                
                            </div>
                            <div class="row" style="margin-top: 10px;">
                                <div class="col-lg-12">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link nav-link-ped active" data-toggle="tab" href="#dvprodutoscmp">Produtos</a>
                                        </li>
                                        <li v-show="parseInt(detpedido.tipo) > 0" class="nav-item">
                                            <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvservicoscmp">Serviços</a>
                                        </li>									
                                        <li v-show="parseInt(detpedido.tipo) === 2" class="nav-item">
                                            <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvinformacoesoscmp">Informações da O.S</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvobservacoescmp">Observações</a>
                                        </li>									
                                        <li v-show="parseInt(detpedido.tipo) === 2" class="nav-item">
                                            <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvimagenspedcmp">Imagens</a>
                                        </li>																											
                                    </ul>
                                    <div class="tab-content border-left border-right border-bottom">
                                        <div id="dvprodutoscmp" class="container-fluid tab-pane active">
                                            <div class="row" style="padding: 0px 15px 0px 15px;">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm table-hover" style="margin-top: 15px">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th width="30">Item:</th>
                                                            <th width="100">Codigo:</th>
                                                            <th width="300">Descrição:</th>
                                                            <th width="100">Referência:</th>
                                                            <th width="40">Und:</th>
                                                            <th width="40">Marca:</th>
                                                            <th width="100">Vl. Unitário:</th>
                                                            <th width="50">Qtd:</th>     
                                                            <th v-show="rotinacorte && parseInt(detpedido.stpedido) === 0"></th>                                       
                                                            <th width="100">Vl. Descto:</th>
                                                            <th width="100">Vl. Total:</th>
                                                            <th width="100">Local.:</th>
                                                            <th width="100">Estoque:</th>                                                
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in detpedido.itens" v-bind:key="index" style="font-size: 12px;">
                                                                <td class="text-center">{{item.item}}</td>
                                                                <td>{{item.coddig}}</td>
                                                                <td>{{item.descproduto}}</td>
                                                                <td>{{item.referencia}}</td>
                                                                <td>{{item.unditem}}</td>
                                                                <td>{{item.descmarca}}</td>
                                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario), 2)}}</td>
                                                                <td style="text-align: right;">{{item.qtditem}}</td>
                                                                <td v-show="rotinacorte && parseInt(detpedido.stpedido) === 0" class="text-center">
                                                                    <button type="button" class="btn btn-danger btn-sm btncortaritem" @click.prevent="mtdrotinacorteitem(item)" title="Cortar item"><i class="fa fa-scissors"></i></button>
                                                                </td>					                                                    
                                                                <template v-if="parseInt(item.descacres) === 0">
                                                                    <td v-if="parseInt(item.tipodescacres) === 0" style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario) * parseFloat(item.qtditem) * parseFloat(item.valordescacres) / 100 , 2)}}</td>                                                
                                                                    <td v-else style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.valordescacres), 2)}}</td>                                                
                                                                </template>
                                                                <template v-else>
                                                                    <td></td>
                                                                </template>
                                                                <td style="text-align: right; font-weight: 500;">
                                                                    <i v-show="parseFloat(item.vltotalimposto) > 0" class="fa fa-info-circle text-black-50" v-bind:title="'Imposto do item: R$ '+ mtdformatavalordecimal(parseFloat(item.vltotalimposto), 2)" style="font-size: 18px; float: left;"></i>
                                                                    {{mtdformatavalordecimal(parseFloat(item.vltotal), 2)}}
                                                                </td>
                                                                <td>{{item.localizacao}}</td>
                                                                <td>{{item.descestoque}}</td>
                                                            </tr>
                                                        </tbody>                                        
                                                    </table>
                                                </div>                                                
                                            </div>
                                        </div>
                                        <div id="dvservicoscmp" class="container-fluid tab-pane">
                                            <div class="row" style="padding: 0px 15px 0px 15px;">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm table-hover" style="margin-top: 15px">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th width="50">Código:</th>
                                                            <th width="300">Descrição do serviço:</th>
                                                            <th width="100">Técnico:</th>
                                                            <th width="100">Vl. Unitário:</th>
                                                            <th width="50">Qtd:</th>     
                                                            <th width="100">Vl. Total:</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in detpedido.servicos" v-bind:key="index" style="font-size: 12px;">
                                                                <td>{{item.idservico}}</td>
                                                                <td>{{item.descservico}}</td>
                                                                <td>{{item.nometecnico}}</td>
                                                                <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlservico), 2)}}</td>
                                                                <td style="text-align: right;">{{item.qtdservico}}</td>
                                                                <td style="text-align: right; font-weight: 500;">
                                                                    {{mtdformatavalordecimal(parseFloat(item.vltotal), 2)}}
                                                                </td>
                                                            </tr>
                                                        </tbody>                                        
                                                    </table>
                                                </div>                                                
                                            </div>                                            
                                        </div>
                                        <div id="dvinformacoesoscmp" class="container-fluid tab-pane">
										    <div class="row" style="padding-top: 15px; padding-bottom: 15px;">                                        
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                                                    <div class="row">
                                                        <div class="col-sm-12 col-md-5 col-lg-5">
                                                            <label for="edobjetooscmp">Objeto:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edobjetooscmp" v-model="detpedido.objeto" disabled data-bv-group=".group" maxlength="20">
                                                        </div>																						
                                                        <div class="col-sm-12 col-md-3 col-lg-3">
                                                            <label for="edidentificadoroscmp">Identificador:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edidentificadoroscmp" v-model="detpedido.identificador" disabled data-bv-group=".group" maxlength="20">
                                                        </div>											
                                                        <div class="col-sm-12 col-md-3 col-lg-3">
                                                            <label for="edmarcacaooscmp">Marcação:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edmarcacaooscmp" v-model="detpedido.marcacao" disabled data-bv-group=".group" maxlength="20">
                                                        </div>
                                                        <div class="col-sm-12 col-md-3 col-lg-3">
                                                            <label for="ednrserieoscmp">Número de série:</label>
                                                            <input type="text" class="form-control form-control-sm" id="ednrserieoscmp" v-model="detpedido.nrserie" disabled data-bv-group=".group" maxlength="20">
                                                        </div>
                                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                                            <label for="edmarcaoscmp">Marca:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edmarcaoscmp" v-model="detpedido.marca" disabled data-bv-group=".group" maxlength="20">
                                                        </div>
                                                        <div class="col-sm-12 col-md-5 col-lg-5">
                                                            <label for="edmodelooscmp">Modelo:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edmodelooscmp" v-model="detpedido.modelo" disabled data-bv-group=".group" maxlength="20">
                                                        </div>
                                                        <div class="col-sm-12 col-md-12 col-lg-12">
                                                            <label for="eddefeitoapresentadooscmp">Defeito apresentado:</label>
                                                            <input type="text" class="form-control form-control-sm" id="eddefeitoapresentadooscmp" v-model="detpedido.defeitoapresentado" disabled data-bv-group=".group" maxlength="100">
                                                        </div>
                                                        <div class="col-sm-12 col-md-12 col-lg-12">
                                                            <label for="edacessoriososcmp">Acessórios:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edacessoriososcmp" v-model="detpedido.acessorios" disabled data-bv-group=".group" maxlength="100">
                                                        </div>
                                                        <div class="col-sm-12 col-md-12 col-lg-12">
                                                            <label for="edoutrasinformacoesoscmp">Outras informações:</label>
                                                            <input type="text" class="form-control form-control-sm" id="edoutrasinformacoesoscmp" v-model="detpedido.outrasinformacoes" disabled data-bv-group=".group" maxlength="100">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                                                    <div class="row">
                                                        <div class="col-md-12" style="margin-top: 15px;">
                                                            <ul class="list-group">
                                                                <li class="list-group-item text-center text-black-50" style="padding: 5px;">
                                                                    <span style="font-size: 16px; font-weight: 600;">CHECKLIST</span>
                                                                    <i v-show="opcrud < 3" class="fa fa-th-list" id="btmarcartodaschecklist" @click.prevent="mtdmarcartodaschecklist()" data-toggle="tooltip" title="Marcar/Desmarcar todas"></i>
                                                                </li>
                                                                <div style="height: 228px; overflow-y: auto;">
                                                                    <li v-for="(checkitem, index) in detpedido.checklist" v-bind:key="index" class="list-group-item d-flex justify-content-between align-items-center item-op-usuario" style="padding: 10px 15px 10px 15px;">
                                                                        <span class="menuprincipal">{{ checkitem.descricao }}</span>
                                                                        <span v-if="parseInt(checkitem.habilita) === 0"><i class="fa fa-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold;"></i></span>
                                                                        <span v-else><i class="fa fa-check-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold;"></i></span>
                                                                    </li>
                                                                </div>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>                                                                                                
                                            </div>
                                        </div>							
                                        <div id="dvobservacoescmp" class="container-fluid tab-pane">
                                            <div class="row" style="padding-top: 15px; padding-bottom: 15px;">
                                                <div class="col-sm-12">
                                                    <div class="float-right">
                                                        <span><i class="fa fa-pencil-square-o" @click.prevent="mtdeditarobs(detpedido.observacoes)" style="font-size:18px; cursor: pointer; color: rgba(0,0,0,.65); font-weight: bold;"></i></span>
                                                    </div>
                                                </div>	
                                                <div class="col-sm-12">
                                                    <textarea class="form-control center" rows="5" id="txtobservacoes" v-model="detpedido.observacoes" v-bind:disabled="habcampo"></textarea>
                                                </div>		
                                                <template v-if="mostrarbtn">
                                                    <div style="padding-top: 2%;" class="col-sm-12">
                                                        <div class="float-right">
                                                            <button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmaraltobs(detpedido.observacoes, detpedido.id)"><i class="fa fa-check"></i> Confirmar</button>
                                                            <button type="button" class="btn btn-secondary btn-sm" @click.prevent="mtdcancelaraltobs()" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
                                                        </div>
                                                    </div>   
                                                </template>
                                            </div>
                                        </div>                                        
                                        <div id="dvimagenspedcmp" class="container-fluid tab-pane">
                                            <div class="row" style="padding: 15px;">
                                                <div class="col-md-12 border rounded" style="padding-top: 15px;">
                                                    <div v-if="detpedido.imagens.length > 0" class="row">
                                                        <div v-for="(imagem, index) in detpedido.imagens" v-bind:key="index" class="col-md-2 text-center" style="margin-bottom: 15px;">                                            
                                                            <img class="img-thumbnail img-produto" v-bind:src="pathimgview+imagem.patharquivo">                                                  
                                                        </div>
                                                    </div>
                                                    <div v-else class="row">
                                                        <div class="col-md-12 text-center">
                                                            <h6 style="font-size: 12px; padding-bottom: 5px;">Sem imagens para visualização</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
									    </div>
                                    </div>
                                </div>
                            </div>							
                            <div class="row" style="margin-top: 10px;">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                    <label for="edresponsaveloscmp">Responsável:</label>
                                    <input type="text" class="form-control form-control-sm" id="edresponsaveloscmp" v-model="detpedido.responsavel" disabled data-bv-group=".group" maxlength="20">
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                    <label for="edfonecmp">Fone:</label>
                                    <input type="text" v-model="detpedido.fone" disabled
                                        class="form-control form-control-sm" id="edfone" 
                                        v-mask="['(##) ####-####', '(##) #####-####']">
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                    <label for="eddtretornocmp">Dt. Retorno:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtretornocmp" v-model="detpedido.dtretorno" :config="options"
                                            class="form-control form-control-sm" disabled></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>										
                                    </div>
                                </div>	
                                <div v-if="parseInt(detpedido.stpedido)!==0 && parseInt(detpedido.stpedido)!== 1" class="col-12">
                                    <label for="txtmotivocancelamento">Motivo do cancelamento:</label>
                                    <textarea class="form-control center" rows="3" id="txtmotivocancelamento" v-model="detpedido.motivocancelamento" disabled></textarea>
                                </div>																							
                            </div>									                            
                        </div>
					</div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" @click.prevent="resetaobs()" data-dismiss="modal" style="width: 150px;"><i class="fa fa-sign-out"></i> Sair</button>
                    </div>					
				</div>
			</div>
		</div>

		<!-- Modal para corte do item -->
		<div class="modal fade" id="mdcorteitemcmp" tabindex="-1" style="z-index: 1052;">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-scissors"></i> Corte do item</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<label for="editemcortecmp">Item:</label>
							<input type="text" style="font-size: 10px; font-weight: bold;" class="form-control form-control-sm" id="editemcortecmp" :value="itemcortar.idproduto +' - '+itemcortar.descproduto" data-bv-group=".group" disabled>
						</div>													
						<div class="col-12">
							<label for="edqtditemcortarcmp">*Qtd. corte:</label>
							<money type="text" class="form-control form-control-sm" id="edqtditemcortarcmp" v-model="qtditemcortar" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
						</div>						
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmarcorteitem()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>				        
			</div>
			</div>
		</div>        
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
    name: 'cmpdetalhespedido',
    props:[
                'idpedido',
                'rotinacorte'
          ],
    data: function() {
        return {
            detpedido           : {
                itens    : [],
                servicos : [],
                imagens  : [],
                checklist: []                                
            },
            mostrar             : false,

            //pega o path do diretorio padrão das imagens
            pathimgview          : this.$store.state.configpaths.pathimagens,		
            
            habcampo    : true, // habilitar edição de obcervações 
            mostrarbtn  : false,
            vobsold     : '',

            //variáis do item a ser cortado
            itemcortar			: [],
            qtditemcortar		: 1,            

            money				: {
                decimal         : ',',
                thousands       : '.',
                prefix          : '',//aqui colocar o cifrão se for necessário
                precision       : 2,
                masked          : false
            }            
        };
    },
    methods: {
        resetaobs(){
            this.habcampo   = true;
            this.mostrarbtn = false;
            this.vobsold    = '';
        },
        mtdconfirmaraltobs(obs, idobs){
                let vself       = this;
                let loader      = vself.$loading.show();
                let parametros  = [

                    {parametro: 'op',               valor       : 'mudarobs'},
                    {parametro: 'idclientesac',     valor       : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'obs',              valor       : obs},
                    {parametro: 'obsold',           valor       : vself.vobsold},
                    {parametro: 'idobs',            valor       : idobs},
                    {parametro: 'idfilial',         valor       : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor       : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor       : '020Z.010Z.200Z'},

                ];

                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();                
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Alterado com sucesso!', 'Informação!')
                        vself.habcampo   = true;
                        vself.mostrarbtn = false;
                        vself.vobsold    = '';
                    }else{
                        let tpret = response.data.substring(0,1)
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!')
                                break
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!')
                                break
                        }

                        vself.mtdcancelaraltobs();
                    }          
                }).catch(function (response) {
                    loader.hide();
                });
        },
        mtdcancelaraltobs(){
            this.habcampo = true
            this.mostrarbtn = false
            this.detpedido.observacoes = this.vobsold;
            this.vobsold = '';
        },
        mtdeditarobs(obs){
            if (!util.opcaousuario('020Z.010Z.200Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {
                this.vobsold = obs;
                this.habcampo = false;
                this.mostrarbtn = true;
                setTimeout(() => {
                    $('#txtobservacoes').focus();
                }, 300);
            }
           
        },
        mtdformatavalordecimal(valor, digitos){
            return util.formatavalordecimais(valor, digitos);
        },
        mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
		},        
        mtdlocalizarpedido(){
            let vself       = this;
            if (vself.idpedido !== ''){                
                let loader      = vself.$loading.show();
                let filtro      = ' and p.id='+vself.idpedido;
                let parametros  = [
                {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'diretorioimagens', valor   : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'idclientesac', valor       : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor       : filtro},
                        {parametro: 'limit',        valor       : 1},
                        {parametro: 'offset',       valor       : 0},
                    ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();                
                    if (response.data.pedidos.length > 0){
                        vself.mostrar   = true;
                    }
                    vself.detpedido = response.data.pedidos[0];                
                }).catch(function (response) {
                    loader.hide();
                });
            }
        },
        mtdrotinacorteitem(item){
            this.itemcortar 	= JSON.parse(JSON.stringify(item));
            this.qtditemcortar  = this.itemcortar.qtditem;
            $('#mdcorteitemcmp').modal('show');
        },
        mtdconfirmarcorteitem(){
            let vself = this;
            if (parseFloat(vself.qtditemcortar) <= 0){
                vself.$toastr.w('Quantidade inválida!', 'Atenção!');
                $('#edqtditemcortarcmp').focus();
                return;
            }
            if (parseInt(vself.itemcortar.fracionado) === 0){
                if (!Number.isInteger(vself.qtditemcortar)){
                    vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                    $('#edqtditemcortarcmp').focus();
                    return;
                }
            }				
            if (parseFloat(vself.qtditemcortar) > parseFloat(vself.itemcortar.qtditem)){
                vself.$toastr.w('Quantidade de corte não pode ser maior que a quantidade do item!', 'Atenção!');
                $('#edqtditemcortarcmp').focus();
                return;
            }				
            $.confirm({
                title: 'Confirmação!',
                content: 'Confirma corte do item?',
                icon: 'fa fa-question-circle',
                escapeKey: true,
                backgroundDismiss: false,
                escapeKey: 'nao',
                type: 'dark',
                typeAnimated: true,
                buttons: {
                sim: {
                    text: '<u>S</u>im',
                    keys: ['s', 'S'],
                    btnClass: 'btn-blue',
                    action: function () {        
                        vself.mtdgravarcortaritem();
                    },
                },
                nao: {
                    text: '<u>N</u>ão',
                    keys: ['n', 'N'],
                    action: function () {
                        $('#edqtditemcortarcmp').focus();
                    }
                }
                }
            });								
        },
        mtdgravarcortaritem(){
            let vself = this;
            let loader       = vself.$loading.show()
            let parametros   = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'cortaritem'},
                {parametro: 'qtdcorte',     valor : vself.qtditemcortar},
                {parametro: 'idpedido',     valor : vself.detpedido.id},
                {parametro: 'idproduto',    valor : vself.itemcortar.idproduto},
                {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                {parametro: 'codop',        valor : '020Z.010Z.034Z'},
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
            retorno.then(function (response) {
                loader.hide();
                if ($.isNumeric(response.data)){
                    vself.$toastr.s('Corte realizado com sucesso!', 'Informação!')
                    vself.mtdlocalizarpedido();
                    $('#mdcorteitemcmp').modal('hide');
                }else{
                    let tpret = response.data.substring(0,1)
                    switch (tpret) {
                        case 'I':
                            vself.$toastr.w(response.data.substring(4), 'Atenção!')
                            break
                        case 'E': default:
                            vself.$toastr.e(response.data.substring(4), 'Erro!')
                            break
                    }
                }
            }).catch(function (response) {
                loader.hide()
                vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!')
            });				
        }
    },
    mounted: function() {
        let vself = this;
        
        $("#mddetalhespedido").on('shown.bs.modal', function(){
            //console.log('Pedido: '+vself.idpedido);
            $('.nav-tabs a[href="#dvprodutoscmp"]').tab('show');
            setTimeout(() => {
                vself.mtdlocalizarpedido();
            }, 300);            
        });
        $("#mddetalhespedido").on('hide.bs.modal', function(){
            vself.idpedido       = '';
            vself.mostrar        = false;
            vself.detpedido      = [];
            vself.detpedido.itens    = [];
            vself.detpedido.servicos = [];
            vself.detpedido.imagens  = [];
            vself.detpedido.checklist= [];           
        });

        $('#mdcorteitemcmp').on('shown.bs.modal', function (e) {
			$('#edqtditemcortarcmp').focus();
		});                                
    },    
    computed:{ 
    },
    watch: {
    }
}
</script>
<style>   
    .bdg-det-icone-guia{
        position: absolute;
        top: 25px;
        right: 18px;
    }
</style>